import ServiceForm from './ServiceForm';

export default function CTASection() {
  return (
    <section id="cta" className="bg-[#0A2540] py-24 px-6 relative overflow-hidden">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-5"
        style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '32px 32px' }}
      />

      <div className="relative max-w-screen-xl mx-auto">
        <div className="max-w-2xl">
          <p className="text-[#FF6B00] text-sm font-bold uppercase tracking-widest font-heading mb-3">
            Ready to get started?
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white font-heading leading-tight mb-4">
            Help Is Just A Click Away.
          </h2>
          <p className="text-white/70 text-base font-body leading-relaxed mb-2">
            With risk-free quotes and 24/7 support, you&apos;re in good hands. Tell us your service and zip
            code — we&apos;ll handle the rest and have a top-rated local pro calling you shortly.
          </p>

          {/* Trust badges */}
          <div className="flex flex-wrap gap-3 mb-1">
            {['Licensed & Insured', 'Background Checked', 'Upfront Pricing'].map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#10B981] bg-[#10B981]/10 border border-[#10B981]/20 px-3 py-1 rounded-full"
              >
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-[#10B981] text-xs" />
                </div>
                {badge}
              </span>
            ))}
          </div>

          <ServiceForm
            formAction="https://readdy.ai/api/form/d7416kj41deorl02ek80"
            formId="cta-lead-form"
            dark
          />
        </div>

        {/* Side panel stats */}
        <div className="hidden lg:flex absolute right-0 top-0 bottom-0 items-center">
          <div className="flex flex-col gap-4 pr-4">
            {[
              { icon: 'ri-phone-fill', text: '24/7 Live Dispatch' },
              { icon: 'ri-map-pin-2-fill', text: 'All 50 States Covered' },
              { icon: 'ri-star-fill', text: '4.9 Avg Contractor Rating' },
              { icon: 'ri-time-fill', text: 'Same-Day Appointments' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-3 text-white/60">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 border border-white/10">
                  <i className={`${item.icon} text-[#FF6B00] text-sm`} />
                </div>
                <span className="text-sm font-body whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
